'use client';

import type { Profile } from '@fe-cnyes/fe-dfp';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import useMediaQuery from '@fe-news/hooks/use-media-query';
import dynamic from 'next/dynamic';

const DynamicAdSlot = dynamic(() => import('@fe-news/components/DynamicAd/BaseDynamicAd'), {
  ssr: false
});

type DynamicAdProp = {
  desktopAdProfile?: Profile | null;
  mobileAdProfile?: Profile | null;
  isDesktop?: boolean;
};

const DynamicAd = ({ desktopAdProfile, mobileAdProfile, isDesktop }: DynamicAdProp) => {
  const isDesktopProfile = useMediaQuery(`(min-width:${SCREEN_SIZE.DESKTOP}px)`, isDesktop);

  let profile: Profile | null = null;

  if (desktopAdProfile && isDesktopProfile) {
    profile = desktopAdProfile;
  } else if (mobileAdProfile && !isDesktopProfile) {
    profile = mobileAdProfile;
  }

  return profile && <DynamicAdSlot profile={profile} />;
};

export default DynamicAd;
